import { createLucideIcon } from "lucide-react";

export const Sorting2 = createLucideIcon(
    "Sorting2",
    [
        [
            "path",
            {
                d: "M11 12L19 11.9999",
                key: "1kegt4",
            },
        ],
        [
            "path",
            {
                d: "M11 16H21",
                key: "rjonaz",
            },
        ],
        [
            "path",
            {
                d: "M11 4H14",
                key: "1lh5lp",
            },
        ],
        [
            "path",
            {
                d: "M11 8H16",
                key: "bxlyao",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21C4.7998 21 3.4915 19.0057 3 18.5",
                key: "nkc38e",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21C6.2002 21 7.5085 19.0057 8 18.5",
                key: "1yvnig",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21V3",
                key: "1mc4pb",
            },
        ],
    ],
);
